'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BreadcrumbItem = require('react-bootstrap/lib/BreadcrumbItem');

var _BreadcrumbItem2 = _interopRequireDefault(_BreadcrumbItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _BreadcrumbItem2.default;